/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_NewInputs */

const cs_ebr_pairing_new = /** @type {(inputs: Ebr_Pairing_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noví`)
};

const en_ebr_pairing_new = /** @type {(inputs: Ebr_Pairing_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`new`)
};

/**
* | output |
* | --- |
* | "new" |
*
* @param {Ebr_Pairing_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_new = /** @type {((inputs?: Ebr_Pairing_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_new(inputs)
	return cs_ebr_pairing_new(inputs)
});